import { useCallback, useState } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { View } from 'foundations-components/components/View';
import { AbstractRatingInput } from 'foundations-components/transitional/components/AbstractRatingInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useReviewContext } from '../context/ReviewContextProvider';
import { PillIcon, StarRating, StarRatingDisabled } from '../AbstractRatingIcons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ReviewRatingInput({
  dataTestId,
  disabled,
  fieldKey,
  label,
  showTextRating = true,
  tooltip,
  type = 'star',
  size = '900'
}) {
  const {
    getFieldValidation,
    onUpdateReview,
    review
  } = useReviewContext();
  const {
    locked,
    required
  } = getFieldValidation('ratings', fieldKey);
  const rating = review.ratings[fieldKey];
  const [ratingText, setRatingText] = useState(rating ? unescapedText(`trellisEcosystem.reviews.ratingDescriptions.${rating}`) : '');
  const onHoveredValueChange = useCallback(({
    target: {
      value
    }
  }) => {
    if (!value && !rating) {
      setRatingText('');
    } else {
      setRatingText(unescapedText(`trellisEcosystem.reviews.ratingDescriptions.${value || rating}`));
    }
  }, [rating]);
  let IconComponent;
  switch (type) {
    case 'pill':
      IconComponent = PillIcon;
      break;
    default:
      if (disabled || locked) {
        IconComponent = StarRatingDisabled;
      } else {
        IconComponent = StarRating;
      }
      break;
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    required: required,
    tooltip: tooltip,
    children: /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      direction: "row",
      children: [/*#__PURE__*/_jsx(AbstractRatingInput, {
        "data-test-id": dataTestId,
        disabled: disabled || locked,
        defaultValue: rating || 0,
        IconComponent: IconComponent,
        margin: "0",
        onChange: ({
          target: {
            value
          }
        }) => {
          if (value > 0) {
            setRatingText(unescapedText(`trellisEcosystem.reviews.ratingDescriptions.${value}`));
            onUpdateReview({
              ratings: {
                [fieldKey]: value
              }
            });
          }
        },
        onHoveredValueChange: onHoveredValueChange,
        showPercentage: true,
        size: size,
        value: rating
      }), /*#__PURE__*/_jsx(View, {
        as: "span",
        "data-test-id": `${dataTestId}-label`,
        marginInlineStart: "300",
        children: showTextRating && ratingText
      })]
    })
  });
}